import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { translate } from '@/i18n';
import { useSettingsStore } from '@/store/modules/settings';

import { inject, reactive, ref, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { useCssVar } from '@vueuse/core';
export default /*@__PURE__*/_defineComponent({
  __name: 'VabThemeDrawer',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const $sub = inject('$sub');
    const $unsub = inject('$unsub');
    const $baseLoading = inject('$baseLoading');
    const settingsStore = useSettingsStore();
    const {
      theme,
      device
    } = storeToRefs(settingsStore);
    const {
      saveTheme,
      resetTheme,
      updateTheme
    } = settingsStore;
    const state = reactive({
      drawerVisible: false
    });
    const handleOpenTheme = () => {
      state.drawerVisible = true;
    };
    const updateMenuWidth = () => {
      useCssVar('--el-left-menu-width', ref(null)).value = theme.value.menuWidth;
    };
    const setDefaultTheme = async () => {
      await resetTheme();
      await updateTheme();
      state.drawerVisible = false;
      if (document.body.getBoundingClientRect().width - 1 < 992) location.reload();
    };
    const handleSaveTheme = async () => {
      await saveTheme();
      state.drawerVisible = false;
      if (document.body.getBoundingClientRect().width - 1 < 992) location.reload();
    };
    const shuffle = (val, list) => list.filter(_ => _ !== val)[Math.random() * (list.length - 1) | 0];
    const randomTheme = async () => {
      const loading = $baseLoading(0);
      // 随机换肤重置移除主题，防止代码更新影响样式
      await resetTheme();
      theme.value.themeName = shuffle(theme.value.themeName, ['blue-black', 'blue-white', 'ocean', 'green-black', 'green-white', 'purple-black', 'purple-white', 'red-black', 'red-white']);
      theme.value.columnStyle = shuffle(theme.value.columnStyle, ['vertical', 'horizontal', 'card', 'arrow']);
      // theme.value.background = shuffle(theme.value.background, [
      //   'none',
      //   'vab-background',
      // ])
      theme.value.tabsBarStyle = shuffle(theme.value.tabsBarStyle, ['card', 'smart', 'smooth']);
      theme.value.showTabsIcon = shuffle(theme.value.showTabsIcon, [true, false]);
      theme.value.layout = device.value === 'desktop' ? shuffle(theme.value.layout, ['horizontal', 'vertical', 'column', 'comprehensive', 'common', 'float']) : 'vertical';
      try {
        await updateTheme();
        await saveTheme();
      } finally {
        setTimeout(() => {
          loading.close();
        }, 1000);
      }
    };
    $sub('theme', () => {
      handleOpenTheme();
    });
    $sub('random-theme', () => {
      randomTheme();
    });
    onBeforeUnmount(() => {
      $unsub('theme');
      $unsub('random-theme');
    });
    const __returned__ = {
      $sub,
      $unsub,
      $baseLoading,
      settingsStore,
      theme,
      device,
      saveTheme,
      resetTheme,
      updateTheme,
      state,
      handleOpenTheme,
      updateMenuWidth,
      setDefaultTheme,
      handleSaveTheme,
      shuffle,
      randomTheme,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});